import { render } from "./px-matching-interest-directory-member-modal.vue?vue&type=template&id=15f714b4&ts=true"
import script from "./px-matching-interest-directory-member-modal.vue?vue&type=script&lang=ts"
export * from "./px-matching-interest-directory-member-modal.vue?vue&type=script&lang=ts"

import "./px-matching-interest-directory-member-modal.vue?vue&type=style&index=0&id=15f714b4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__